import { wearables } from '@repo/data';

interface Wearable {
  id: number;
  name: string;
  trim: string;
  set: string;
  set_type: string;
  body_position: string;
  layer: string;
  plurality: string;
  ipfs_hash_svg: string;
}

export const getWearable = async (
  wearableId: number,
): Promise<Wearable | null> => {
  const item = wearables.find((item: Wearable) => item.id === wearableId);

  return item || null;
};
